module.exports = __webpack_public_path__ + "3095a14acdbd6fc09330de4f6f6061ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/news/13/Spotin_x_Books.jpg
// module id = 239
// module chunks = 0